import { render, staticRenderFns } from "./AreaList.vue?vue&type=template&id=7f86f2aa&"
import script from "./AreaList.vue?vue&type=script&lang=js&"
export * from "./AreaList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports